var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MainLayout',{attrs:{"section":"confirm"}},[_c('div',{attrs:{"id":"confirm"}},[_c('h2',[_vm._v("Confirming Email... "),_c('b-spinner',{attrs:{"type":"grow"}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }